module.exports = __webpack_public_path__ + "img/alejandro.4eca6e7f.png";